var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburderMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4167 18.3334H6.58333C5.70888 18.3334 5 19.0423 5 19.9167V20.0834C5 20.9578 5.70888 21.6667 6.58333 21.6667H33.4167C34.2911 21.6667 35 20.9578 35 20.0834V19.9167C35 19.0423 34.2911 18.3334 33.4167 18.3334Z",
    fill: "#810CA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4167 26.6666H6.58333C5.70888 26.6666 5 27.3755 5 28.25V28.4166C5 29.2911 5.70888 30 6.58333 30H33.4167C34.2911 30 35 29.2911 35 28.4166V28.25C35 27.3755 34.2911 26.6666 33.4167 26.6666Z",
    fill: "#810CA8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4167 10H6.58333C5.70888 10 5 10.7089 5 11.5833V11.75C5 12.6245 5.70888 13.3333 6.58333 13.3333H33.4167C34.2911 13.3333 35 12.6245 35 11.75V11.5833C35 10.7089 34.2911 10 33.4167 10Z",
    fill: "#810CA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburderMenuIcon);
export default __webpack_public_path__ + "static/media/Hamburder Menu Icon.05323e9bf34eabcd8e3262a5895d1403.svg";
export { ForwardRef as ReactComponent };